import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import './Withdrawal.scss'
import { withCookies, Cookies } from 'react-cookie'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import HeaderProject from '../../Components/Commons/HeaderProject'

class Withdrawal extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            check: {
                check1: false,
                check2: false,
                check3: false,
                check4: false,
            },
            input: {
                reason: '',
                improvement: '',
            },
        }
    }

    changeInput = (event) => {
        const field = event.target.name
        const input = this.state.input
        input[field] = event.target.value

        this.setState({
            input,
        })
    }

    changeCheck = (event) => {
        const field = event.target.name
        const check = this.state.check
        check[field] = event.target.checked

        this.setState({
            check,
        })
    }

    authDelete = (event) => {
        event.preventDefault()

        let reason = ''

        if (this.state.check.check1) {
            reason = reason + '서비스 및 사이트 이용 불편, '
        }

        if (this.state.check.check2) {
            reason = reason + '유사 서비스로의 이전, '
        }

        if (this.state.check.check3) {
            reason = reason + '서비스 이용 불필요, '
        }

        if (this.state.check.check4) {
            reason = reason + this.state.input.reason
        }

        axios
            .delete(
                `${BACKEND_HOST}/auth/me`,
                {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                    data: {
                        survey1: reason,
                        survey2: this.state.input.improvement,
                    },
                },
            )
            .then((res) => {
                console.log(res)
                this.props.cookies.remove('project_status')
                this.props.cookies.remove('project_name')
                this.props.cookies.remove('project')
                this.props.cookies.remove('project_role')
                this.props.cookies.remove('demo')
                this.props.cookies.remove('token')
                window.location.href = '/withdrawal/complete'
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        console.log(this.state)

        //신청 버튼 활성화
        let submitButton = false

        if (this.state.check.check1 || this.state.check.check2 || this.state.check.check3 || this.state.check.check4) {
            if (this.state.check.check4 && this.state.input.reason === '') {
                submitButton = false
            } else {
                submitButton = true
            }
        }

        return (
            <div>
                {this.props.cookies.get('project') ? <HeaderMenu /> : <HeaderProject />}
                <div
                    className={
                        this.props.cookies.get('token') && this.props.cookies.get('project')
                            ? 'section_wrap section_wrap_menu'
                            : 'section_wrap'
                    }>
                    <div
                        className={
                            this.props.cookies.get('project')
                                ? 'withdrawal_wrap common_detail'
                                : 'withdrawal_wrap common_detail withdrawal_wrap_n'
                        }>
                        <form className="section" onSubmit={this.authDelete}>
                            <h1>회원탈퇴</h1>
                            <h2>탈퇴한 아이디는 복구가 불가하오니 신중하게 선택해 주시기 바랍니다!</h2>
                            <div className="article_wrap">
                                <div>
                                    <div className="sub_title">
                                        <div className="green_line"></div>
                                        유의사항
                                    </div>
                                    <ul className="noti_box">
                                        <li>
                                            - 관련법 및 개인정보처리방침에 따라 보유하는 경우를 제외하고, 여러분의
                                            정보는 모두 삭제됩니다.
                                        </li>
                                        <li>
                                            - 작성한 게시물 중 공용게시판에 등록된 경우, 다른 이용자의 정상적인 서비스
                                            이용을 위해 서비스 내에서 삭제되지 않습니다.
                                        </li>
                                        <li>
                                            - 유료서비스의 환불할 금액이 있는 경우, 별도의 환불신청을 해주셔야 합니다.
                                        </li>
                                    </ul>
                                </div>

                                <div>
                                    <p className="refer_text1">*중복선택 가능</p>
                                    <div className="sub_title">
                                        <div className="green_line"></div>
                                        탈퇴사유
                                    </div>
                                    <ul className="reason_wrap">
                                        <li>
                                            <label className="checkbox_wrap">
                                                <input
                                                    type="checkbox"
                                                    name="check1"
                                                    onChange={this.changeCheck}
                                                    checked={this.state.check1}
                                                />
                                                <span className="checkmark"></span>
                                                서비스 및 사이트 이용 불편
                                            </label>
                                        </li>
                                        <li>
                                            <label className="checkbox_wrap">
                                                <input
                                                    type="checkbox"
                                                    name="check2"
                                                    onChange={this.changeCheck}
                                                    checked={this.state.check2}
                                                />
                                                <span className="checkmark"></span>
                                                유사 서비스로의 이전
                                            </label>
                                        </li>
                                        <li>
                                            <label className="checkbox_wrap">
                                                <input
                                                    type="checkbox"
                                                    name="check3"
                                                    onChange={this.changeCheck}
                                                    checked={this.state.check3}
                                                />
                                                <span className="checkmark"></span>
                                                서비스 이용 불필요
                                            </label>
                                        </li>
                                        <li>
                                            <label className="checkbox_wrap">
                                                <input
                                                    type="checkbox"
                                                    name="check4"
                                                    onChange={this.changeCheck}
                                                    checked={this.state.check4}
                                                />
                                                <span className="checkmark"></span>
                                                기타
                                            </label>
                                        </li>
                                    </ul>
                                    {this.state.check.check4 && (
                                        <input
                                            className="input"
                                            name="reason"
                                            value={this.state.input.reason}
                                            onChange={this.changeInput}
                                            type="text"
                                            placeholder="기타 사유를 적어주세요. (필수)"
                                        />
                                    )}
                                </div>

                                <div>
                                    <div className="sub_title">
                                        <div className="green_line"></div>
                                        개선사항
                                    </div>
                                    <textarea
                                        className="textarea"
                                        name="improvement"
                                        value={this.state.input.improvement}
                                        onChange={this.changeInput}
                                        placeholder="남겨주신 정보를 바탕으로 보다 좀 더 나은 서비스를 제공해 드리기 위해 더욱 노력하겠습니다."
                                        type="text"></textarea>
                                    <p className="refer_text2">
                                        *마케팅 수신 정보 삭제는 일주일 정도 소요될 수 있습니다.
                                    </p>
                                </div>

                                <button
                                    type="submit"
                                    className={`${submitButton && 'submit_btn_on'}`}
                                    disabled={submitButton ? false : 'disabled'}>
                                    회원 탈퇴 신청
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(Withdrawal)



// WEBPACK FOOTER //
// ./Src/Containers/User/Withdrawal.js